import React, { useCallback, useMemo, useState } from 'react'
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import { Poule, getJournees } from '../types'
import { JourneePaginator } from './JourneePaginator'
import { useCompetitionProps } from '../../hooks/useCompetitionProps'

interface Attributes {
    poule: Poule | null
    selected_numero_journee: string
}

const JourneeSelector = (attributes) => {
    const [fetchingJournee, setFetchingJournee] = useState<null | string>(null)
    const onFinishFetching = useCallback(() => {
        setFetchingJournee(null)
    }, [])

    const {
        attributes: { poule, selected_numero_journee },
        params: { numero_journee },
        setParams,
    } = useCompetitionProps<Attributes>({
        initDataFromPhpFirstRendering: attributes,
        allowedParamsUpdatesProps: {
            numero_journee: true,
        },
        onFinish: onFinishFetching,
    })

    const journees = useMemo(
        () => (poule ? getJournees(poule, { sortBy: 'journee_numero' }) : []),
        [poule],
    )
    const labels = useMemo(() => ['0', ...journees.map((x) => `J${x.journee_numero}`)], [journees])

    const selectedNumeroJournee = selected_numero_journee ?? numero_journee ?? 1

    const handleChange = useCallback(
        (_: any, p: number) => {
            const newNumero = String(journees[p - 1]?.journee_numero)
            if (newNumero === selectedNumeroJournee) return
            setFetchingJournee(newNumero)
            setParams('numero_journee', newNumero)
        },
        [journees, selectedNumeroJournee, setParams],
    )

    const page = 1 + journees.findIndex((x) => selectedNumeroJournee === String(x.journee_numero))
    const loadingPage = fetchingJournee
        ? 1 + journees.findIndex((x) => fetchingJournee === String(x.journee_numero)) || null // not found index => null
        : null

    if (!poule || journees.length <= 1) return null

    return (
        <JourneePaginator
            loadingPage={loadingPage}
            pageCount={journees.length}
            labels={labels}
            page={page}
            onChange={handleChange}
        />
    )
}

const JourneeSelectorBlock = (attributes) => (
    <BlockWrapper.Without>
        <JourneeSelector {...attributes} />
    </BlockWrapper.Without>
)

export default defineBlock({
    Block: JourneeSelectorBlock,
})
